import { Module } from 'vuex'

import { RootState, MonitorState } from '../../types/store'
import { Gender } from '../../types/receipt'

import { getters } from './getters'
import { actions } from './actions'
import { mutations } from './mutations'

const state: MonitorState = {
  monitor: {
    id: '',
    gender: Gender.OTHER,
    birthday: null,
    age: null,
    zipcode: null,
    prefecture: null,
    createdAt: new Date(),
    updatedAt: new Date(),
    deletedAt: null,
  },
  monitors: [],
  total: -1,
  isMonitorsLoading: false,
}

export const monitor: Module<MonitorState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
